import z from "zod";

export const AVATAR_COLORS = [
  "chart-1",
  "chart-2",
  "chart-3",
  "chart-4",
  "chart-5",
  "ring",
] as const;

export const avatarColorSchema = z.enum(AVATAR_COLORS);
export type AvatarColor = z.infer<typeof avatarColorSchema>;

// TODO: Remove all 'chart-1' instances and use this DEFAULT.
export const DEFAULT_AVATAR_COLOR: AvatarColor = "chart-1";
